import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

function Floor4K4() {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const imageRef = useRef(null);

    
  const customFloorUrl = '4';
  // Initial hover animation with delay
  useEffect(() => {
    let stopTimeout;
    const delay = setTimeout(() => {
      setIsHovered(true);
      stopTimeout = setTimeout(() => {
        setIsHovered(false);
      }, 300);
    }, 6000);
    return () => {
      clearTimeout(delay);
      if (stopTimeout) clearTimeout(stopTimeout);
    };
  }, []);

  // Detect screen size to adjust behavior
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Handle clicking outside to reset hover effect on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (imageRef.current && !imageRef.current.contains(event.target)) {
        setIsHovered(false);
        setIsClicked(false);
      }
    };

    if (isMobile && isClicked) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobile, isClicked]);

  const handleClick = () => {
    if (isMobile) {
      if (!isClicked) {
        setIsHovered(true); // First tap acts as hover
        setIsClicked(true);
      } else {
        // Navigate to floor page when ready
        navigate("/same-floors-34", { state: { customFloorUrl } }); // Navigate to SameFloors34 page
      }
    } else {
      // Navigate to floor page when ready
      navigate("/same-floors-34", { state: { customFloorUrl } }); // Navigate to SameFloors34 page
    }
  };

  return (
    <>
      {/* Green Overlay (Shown on Hover or Click for Mobile) */}
      <img
        className={`absolute w-[32.0vw] left-[43.8vw] top-[34.17vw] cursor-pointer transition-opacity duration-300 ${isHovered ? "opacity-100" : "opacity-0"
          }`}
        src="/images/click/clickable-images/Floors/Floor4-K4-Green.png"
        alt=""
        aria-hidden="true"
        style={{ pointerEvents: 'none', transform: 'rotate(1.85deg) scaleY(0.92) skewY(-1.5deg)', transformOrigin: 'left center' }}
      />

      <button
        ref={imageRef}
        type="button"
        aria-label="Kati 4"
        className="absolute w-[32.0vw] h-[3.35vw] left-[43.8vw] top-[35.65vw] cursor-pointer bg-transparent border-0 p-0"
        onMouseEnter={() => !isMobile && setIsHovered(true)} // Hover effect for laptop
        onMouseLeave={() => !isMobile && setIsHovered(false)} // Only reset hover on laptop
        onClick={handleClick} // Click-to-hover for mobile
        style={{ transform: 'rotate(1.85deg) scaleY(0.92) skewY(-1.5deg)', transformOrigin: 'left center' }}
      />

      {/* Tooltip on Hover or Click (for Mobile) */}
      {isHovered && (
        <span className="absolute left-[76.5vw] top-[38.59vw] bg-[#192929] montserrat font-medium text-white text-xs md:text-base px-2 lg:px-4 py-2 lg:py-3 shadow-md">
          Kati 4
        </span>
      )}
    </>
  );
}

export default Floor4K4;




